/**
 * This composition function implements the logic around which search types should be available to
 * the user in the Type field.
 */
export default (profile, criteriaContext) => {

  const { isDentalOnly, isMedicalOnly } = usePlan(profile, criteriaContext)

  const dentalOnly = computed(() => isDentalOnly())

  const medicalOnly = computed(() => isMedicalOnly())

  //Note for the hospital types, we are representing a type ( hospitals ) and also a subtype ( 1, 2, 3 )
  //We will represent that by colon deliminating them and pull apart on the server.
  const medicalItems = ref([
    { label: 'Doctor', value: 'doctor' },
    { label: 'Medical clinic', value: 'medical' },
    { label: 'Urgent care', value: 'urgent' },
    { label: 'Hospital', value: 'hospital:1' },
    { label: 'Surgical center', value: 'hospital:2' },
    { label: 'Skilled nursing facility', value: 'hospital:3' },
    { label: 'Specialty care location', value: 'hospital' },
  ])

  const dentalItems = ref([
    { label: 'Dentist', value: 'dentist' },
    { label: 'Dental clinic', value: 'dental' },
  ])

  const allItems = computed(() => {
    const med = medicalItems.value
    const den = dentalItems.value

    return [...med, ...den]
  })

  const items = computed(() => {
    if (medicalOnly.value) return medicalItems.value
    if (dentalOnly.value) return dentalItems.value

    return allItems.value
  })

  return { items }
}